
<div class="login-container">

	<!-- Page container -->
	<div class="page-container">

		<!-- Page content -->
		<div class="page-content">

			<!-- Main content -->
			<div class="content-wrapper">

				<!-- Content area -->
				<div class="content">

					<!-- Simple login form -->
					<form name="loginform">
                        <div class="row">
                            <div class="col-md-4 col-md-offset-4">
                                <div class="row">
                                    <div class="col-md-8 col-md-offset-2 col-sm-4 col-sm-offset-4 col-xs-8 col-xs-offset-2">
                                        <img class="oc-web-logo img-responsive" src="assets/images/oncore/logo.png">
                                        <h1 class="font-std">ONCOREWEB</h1>
                                    </div>
                                </div>
                                <div class="row">
                                    <div>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12" >
                                        <div class="form-group">
                                            <span class="help-block text-center no-margin text-warning" [textContent]="error"></span>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group has-feedback has-feedback-left">
                                            <input type="text" required name="username" class="form-control" placeholder="Username" autocomplete="off" (keyup)="toShowHideButton()" [(ngModel)]="username">
                                            <div class="form-control-feedback">
                                                <i class="icon-user text-muted"></i>
                                            </div>
                                        </div>

                                        <div class="form-group has-feedback has-feedback-left">
                                            <input #pswd required name="password" type="password" class="form-control" placeholder="Password" (keyup)="toShowHideButton()" [(ngModel)]="password">
                                            <div class="form-control-feedback">
                                                <i class="icon-lock2 text-muted"></i>
                                            </div>
                                        </div>

                                        <div class="form-group" *ngIf="isValidForm">
                                            <button type="submit" class="btn bg-danger-400 btn-block" (click)="login()">Sign in <i class="icon-circle-right2 position-right"></i></button>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="text-center"><img src="assets/images/oncore/right-on-track.png" class="rightontrack"></div>
                                </div>
                            </div>
                        </div>
					</form>
					<!-- /simple login form -->


					<!-- Footer -->
					<div class="footer text-muted text-center">
						&copy; {{ currentYear }}. <a href="#" class="font-std">ONCORE</a>
					</div>
					<!-- /footer -->

				</div>
				<!-- /content area -->

			</div>
			<!-- /main content -->

		</div>
		<!-- /page content -->

	</div>
	<!-- /page container -->

</div>
